<template>
  <v-app>
    <router-view v-if="$auth.ready()" />
    <loading v-else />
  </v-app>
</template>


<script>
import App from './App';
import Loading from './views/Loading';

export default {
  name: 'entry-point',

  components: {
    App,
    Loading
  }
}
</script>

<style lang="stylus">
@import './assets/style/style.scss';
</style>